export default {
  getInterviewAnswer: (state) => state.interviewAnswer,
};
